var productSlider = {
  
  slides: null,
  slideWidth: 0,
  slideCount: 0,
  
  init: function(selector) {
    productSlider.slides = $(selector);
    
    productSlider.slideCount = $(selector).find('li').length;
    productSlider.slideWidth = $(selector).find('li').outerWidth();
  },
    
  currentIndex: function() {
    var _left  = -(parseInt($(productSlider.slides).css('margin-left').replace('px', '')));
    
    if (_left > 0) {
    	return Math.floor(_left / productSlider.slideWidth) + 1;
  	} else {
      	return 1;
    }
  },
  
  slideTo: function(index) {
    if (index < 1) { index = 1; }
    if (index > productSlider.slideCount - 2) { index = productSlider.slideCount - 2; }
    index--;
    
    $(productSlider.slides).css('margin-left', -(index * productSlider.slideWidth) + 'px');
  },
  
  
  next: function() {
   productSlider.slideTo(productSlider.currentIndex() + 1); 
  },
  
  prev: function() {
   productSlider.slideTo(productSlider.currentIndex() - 1); 
  }
  
};


function backToProducts() {
 window.history.back(); 
}

$(document).ready(function() {
  
  if (localStorage.getItem('hasSelectedBox') === 'yes') {
   	var _btn = $('.product-single__purchase-btn');
    $(_btn).text('Back to Products');
    $(_btn).attr('href', '#');
    $(_btn).attr('onclick', 'javascript:backToProducts()');
  }
  
  
  if ($('.product-single__ingredients span').text().trim().length <= 0) {
    $('.product-single__ingredients h3').remove();
    
    if ($('.product-single__icons').html().trim().length <= 0) {
     	$('.product-single__icons').remove(); 
      
      if ($('.product-single__nutrition-info__col2').html().trim().length <= 0) {
       	$('.product-single__footer').remove(); 
      }
    }
  }
  
  if ($('.product-single__thumbnails').children().length <= 0) {
   	 $('.thumbnails-wrapper').remove();
  }
  
  productSlider.init('.product-single .product-single__thumbnails');
  
  $('.thumbnail-next').click(function() {
    productSlider.next();
  });
  $('.thumbnail-prev').click(function() {
    productSlider.prev();
  });
  
  var _width = 0;
  $('.product-single .product-single__thumbnails li').each(function() {
    _width += $(this).outerWidth();
  });
  
  $('.product-single .product-single__thumbnails').width(_width);
  
});